export const MAX_SPRINT_NAME_CHARS = 40;

export function sanitizeSprintName(raw: unknown, fallback = "Sprint"): string {
  const text = typeof raw === "string" ? raw : String(raw ?? "");
  const collapsed = text.trim().replace(/\s+/g, " ");
  const clamped = collapsed.slice(0, MAX_SPRINT_NAME_CHARS).trim();
  return clamped || fallback;
}
